import { createApp } from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import router from './router'
import VueWechatTitle from 'vue-wechat-title';
import axios from 'axios';
import 'vant/lib/index.css';
import { vant } from '@/config/vant.config.js';
import './css/varable.css'
import wx from 'weixin-js-sdk';

const app = createApp(App);
app.config.globalProperties.$http = axios;
app.config.globalProperties.$cookies = VueCookies
vant(app);
app.use(VueWechatTitle);
app.use(router);
//app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$wx = wx;

router.beforeEach((to, from, next) => {    
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})
app.mount('#app')